/** Shared labels kept in lib: status pills, slash commands, coding CLIs and OpenCode plans. */
export default {
  statusBacklog: "Backlog",
  statusTodo: "Todo",
  statusRunning: "Running",
  statusReview: "Review",
  statusDone: "Done",
  statusBlocked: "Blocked",

  commandNew: "Start new session",
  commandTidy: "Arrange frames and zoom to fit",
  commandFocus: "Expand pinned frames and notes",
  commandBoard: "Open task board",
  commandReview: "Review tasks with unread agent updates",
  commandHeart: "Toggle agent heartbeat on/off",
  commandVoice: "Turn Denker's voice on or off",
  commandMax: "Set max parallel agents",

  claudeDescription: "Anthropic's AI CLI — best for Claude models",
  claudeAuth: "Claude account; availability and limits depend on your plan",
  codexDescription: "OpenAI's AI CLI",
  codexAuth: "ChatGPT account; availability and limits depend on your plan",
  opencodeDescription: "75+ models from any provider — bring your own API key",
  opencodeAuth: "Connect a provider account",

  planSubscription: "subscription",
  planPayPerToken: "pay per token",
  planCredits: "credits",
} as const;
